import type { RendererType } from './types';

export const passthroughRenderer: RendererType<unknown> = (children) => children;
